import { useCallback, useMemo } from 'react';

import {
  getBrandAsset,
  getBrandConfig,
  getBrandFaviconLinks,
  getBrandIcon,
  getBrandIconSizes,
  getBrandIconsPath,
  type BrandAssetType,
  type BrandIconType,
} from '@/utils/brand';

/**
 * React hook for accessing brand-specific configurations and assets.
 */
export function useBrand() {
  const brandConfig = useMemo(() => getBrandConfig(), []);
  const assets = useMemo(
    () => ({
      logo: getBrandAsset('logo'),
      logoPng: getBrandAsset('logo', 'png'),
      icon: getBrandAsset('icon'),
      iconPng: getBrandAsset('icon', 'png'),
      whiteLogo: getBrandAsset('white-logo'),
      whiteLogoPng: getBrandAsset('white-logo', 'png'),
      whiteIcon: getBrandAsset('white-icon'),
      whiteIconPng: getBrandAsset('white-icon', 'png'),
    }),
    [],
  );
  const iconSizes = useMemo(() => getBrandIconSizes(), []);
  const faviconLinks = useMemo(() => getBrandFaviconLinks(), []);
  const iconsPath = useMemo(() => getBrandIconsPath(), []);

  const getAsset = useCallback((assetType: BrandAssetType, format: 'svg' | 'png' = 'svg') => {
    return getBrandAsset(assetType, format);
  }, []);

  const getIcon = useCallback((size: number, type: BrandIconType = 'icon') => {
    return getBrandIcon(size, type);
  }, []);

  return {
    displayName: brandConfig.name,
    assets,
    brandConfig,
    getAsset,
    getIcon,
    iconSizes,
    faviconLinks,
    iconsPath,
  };
}
